import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Alert from '../../feature/Alert';
import httpClient from '../../http/HttpRequest';
import { SAVE_UNIT } from '../../data/url';

const UnitModal = ({ show, handleClose }) => {
     const { t } = useTranslation();

     const [unit, setUnit] = useState('');
     const [errors, setErrors] = useState({});

     const closeModal = (action = {}) => {
          handleClose('unitModal', action);
     }

     const handelSubmit = async (e) => {
          e.preventDefault();
          let formErrors = {};
          let valid = true;
          if (!unit) {
               formErrors.unit = 'username_required';
               valid = false;
          }
          if (valid) {
               let payLoad = { name: unit };
               const res = await httpClient.post(SAVE_UNIT, payLoad);
               if (res.requestStatus === 'OK') {
                    const result = res.result;
                    if (result.status === 1) {
                         Alert.success(result.message);
                         closeModal({ status: "RESULT_OK" });
                    } else {
                         Alert.error(result.message);
                    }
               }
          }
          setErrors(formErrors);
     }

     return (
          <Modal show={show} onHide={closeModal} keyboard={false} backdrop="static">
               <form className="pt-3" onSubmit={(e) => handelSubmit(e)}>
                    <Modal.Header>
                         <Modal.Title>{t('new_unit')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <div className="form-group">
                              <label htmlFor='unit'>Unit <span className='text-danger'>*</span> </label>
                              <input
                                   type="text"
                                   className="form-control form-control-lg"
                                   id="unit"
                                   name='unit'
                                   autoComplete="true"
                                   onChange={(e) => setUnit(e.target.value)}
                                   placeholder={t('enter_unit')} />
                              {errors.unit && <p style={{ color: "red" }}>{t(errors.unit)}</p>}
                         </div>
                    </Modal.Body>
                    <Modal.Footer>
                         <Button variant="secondary" onClick={closeModal}>
                              {t('close')}
                         </Button>
                         <Button variant="primary" type='submit'>
                              {t('save')}
                         </Button>
                    </Modal.Footer>
               </form>
          </Modal>
     );
};

export default UnitModal;
